import { combineReducers } from "redux";
import { authReducer } from "./authentication/AuthReducer";
import { homeReducer } from "./home/homeReducer";
export default combineReducers({
  authReducer,
  homeReducer,
});
